import Today from "./Today";
import Todolist from "./Todolist";
import Todo from "./Todo";
import DetailModal from "./DetailModal";
import AddModal from "./AddModal";

const components = { Today, Todolist, Todo, DetailModal, AddModal };
export default components;
